import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

export const list = async () => {
  let response = {};
  try {
    response = await axiosInstance.get(`/me/rounds`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const allUserRounds = async (id) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/users/${id}/rounds`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const show = async ({ id, deleteCache = false }) => {
  let response = {};
  await deleteDataCache(axiosInstanceCached, deleteCache, `round_${id}`);

  try {
    response = await axiosInstanceCached.get(`/rounds/${id}`, {
      id: `round_${id}`,
      cache: {
        ttl: 1000 * 60 * 2,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
